import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	transition: opacity 0.3s ease;

	&.container-enter {
		opacity: 0;
	}

	&.container-enter-active,
	&.container-enter-done,
	&.container-exit {
		opacity: 1;
	}

	&.container-exit-active {
		opacity: 0;
	}
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 20px 40px;
`;

const StyledUpdateTasksContainer = styled.div`
	display: flex;
	gap: 5px;
	align-items: center;
	height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		font-weight: 400;
		font-size: 16px;
	}
`;

const StyledTopRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledTimer = styled.div`
	width: 20px;
	height: 20px;
	mask-image: url(${clock});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${clock});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffb500;
`;

const StyledTasksContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(600px, 1fr));
	justify-content: center;
	align-content: flex-start;
	gap: 20px;
	width: 100%;
	height: 878px;
	margin: 0 auto;
	padding: 20px 40px;
	overflow-y: scroll;
	transition: opacity 0.3s ease;

	&::-webkit-scrollbar {
		display: none;
	}

	&.tab-enter {
		opacity: 0;
	}

	&.tab-enter-active,
	&.tab-enter-done,
	&.tab-exit {
		opacity: 1;
	}

	&.tab-exit-active {
		opacity: 0;
	}
`;

const StyledEmptyTasksContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 878px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledDailyTasksCompletedContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 20px;
	width: 100%;
	height: 878px;

	& > ${Text} {
		font-size: 16px;
		color: rgba(255, 255, 255, 0.5);
		text-align: center;
	}
`;

const StyledTasksCompletedContainer = styled.div`
	height: 40px;
	padding: 0 10px;
	display: flex;
	align-items: center;
	gap: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		font-size: 16px;
		color: rgba(255, 255, 255, 0.5);

		span {
			font-weight: 500;
			color: #ffb500;
		}
	}
`;

const StyledDailyTasksTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		width: 70px;
		font-weight: 500;
		font-size: 16px;
		color: #ffb500;
	}
`;

export {
	StyledContainer,
	StyledDailyTasksCompletedContainer,
	StyledDailyTasksTimerContainer,
	StyledEmptyTasksContainer,
	StyledTasksCompletedContainer,
	StyledTasksContainer,
	StyledTimer,
	StyledTopContainer,
	StyledTopRightContainer,
	StyledUpdateTasksContainer,
};
